<template>
  <component :is="multiline ? 'div' : 'span'" class="warning text-xs" :class="{ 'warning--multiline': multiline }"><slot /></component>
</template>

<script setup lang="ts">
interface Props {
  multiline?: boolean;
}

withDefaults(defineProps<Props>(), {
  multiline: false,
});
</script>

<style lang="scss" scoped>
.warning {
  &::before {
    content: '';
    display: inline-block;
    width: 20px;
    height: 20px;
    padding-left: 16px;
    background-image: url('@/assets/img/warning-yellow.svg');
    background-repeat: no-repeat;
    background-size: contain;
    vertical-align: middle;
    margin-right: 4px;
  }

  &--multiline {
    white-space: pre-line;
  }
}
</style>
